module.exports = __webpack_public_path__ + "img/DarallPro_sign_screen.5cd23796.svg";